import type { Language } from "@/shared/api/book";
import { LANGUAGE_LABEL } from "@/shared/lib/labels";
import { cn } from "@/shared/lib/utils";

/** Nyelvi zászló apró, rajzolt SVG-ként (nem emoji: a design-rendszer 1. pontja szerint
 *  emojit nem használunk, és a zászló-emojit a Windows amúgy sem rajzolja ki).
 *  A jelentés képernyőolvasónak is megvan: `title` + `aria-label`. */
export function Flag({ language, className }: { language: Language; className?: string }) {
  const label = `${LANGUAGE_LABEL[language]} nyelvű`;
  return (
    <svg
      viewBox="0 0 24 16"
      role="img"
      aria-label={label}
      className={cn("h-[11px] w-4 shrink-0 rounded-[2px] ring-1 ring-line", className)}
    >
      <title>{label}</title>
      {language === "hu" ? (
        <>
          <rect width="24" height="16" fill="#fff" />
          <rect width="24" height="5.33" fill="#CE2939" />
          <rect y="10.67" width="24" height="5.33" fill="#477050" />
        </>
      ) : (
        <>
          <rect width="24" height="16" fill="#012169" />
          <path d="M0 0 24 16M24 0 0 16" stroke="#fff" strokeWidth="3.2" />
          <path d="M0 0 24 16M24 0 0 16" stroke="#C8102E" strokeWidth="1.6" />
          <path d="M12 0v16M0 8h24" stroke="#fff" strokeWidth="5.3" />
          <path d="M12 0v16M0 8h24" stroke="#C8102E" strokeWidth="3.2" />
        </>
      )}
    </svg>
  );
}
